import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import _ from "lodash";
import ReactPaginate from "react-paginate";

function IntentList(props) {
  const [IntentList, setIntentList] = useState([]);
  const [IntentList2, setIntentList2] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [Record, seRecord] = useState([]);
  const [paginatedPosts, setpaginatedPosts] = useState();
  // const [pageSize, setpageSize] = useState(10)

  const navigate = useHistory();
  let pageSize = 10;
  // const history=useHistory();

  useEffect(() => {
    LoadIntents();
  }, [pageSize]);

  const LoadIntents = () => {
    const datavalue = {
      id: "0",
      key: "Not",
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getIntentsByPid`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      //console.log("list length", res.data.length)
      seRecord(res.data.length);
      if (res.data.length > 10) {
        setIntentList(res.data);

        setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
      } else {
        setIntentList2(res.data);
      }
    });
  };

  const pageCount = IntentList ? Math.ceil(IntentList.length / pageSize) : 0;
  if (pageCount === 1) return null;
  const pages = _.range(1, pageCount + 1);

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setCurrentPage(currentPage);
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedPost = _(IntentList)
      .slice(startIndex)
      .take(pageSize)
      .value();
    setpaginatedPosts(paginatedPost);
  };

  const EditIntents = (valid, intent, res1, res2, backval) => {
    const IntentInfo = {
      IntId: valid,
      Ques: intent,
      ans1: res1,
      ans: res2,
    };
    // const serializedState = JSON.stringify(IntentInfo);
    // localStorage.setItem('IntentInfo', serializedState);
    localStorage.setItem("IntentInfo", valid);
    localStorage.setItem("BackIntent", backval);

    //console.log("the vaue", valid, intent)
    // setName2({ intents: intent, Ans1: res1, Ans2: res2 });
    // setModal(!modal);
    // window.location.href = "/patient-ai/UpdateIntents";
  };
  const deleteIntent = (value) => {
    //console.log("the vaue", value)

    const datavalue = {
      id: value,
    };

    // const config = {

    //     headers: { 'content-type': 'multipart/form-data' }
    // }
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeleteQuestionAns`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions)
      // axios.post(`https://localhost:7261/DeleteIntents`, datavalue, config)
      .then((res) => {
        //console.log("get value", res);

        //console.log("success")

        // setName({ intents: "", Ans1: "", Ans2: "" });
        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          // window.location.href = "/patient-ai/IntentList";
          // history.push('/patient-ai/IntentList');
          // navigate.push('/IntentAns');
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };
  const BackFunc = () => {
    navigate.push("/index");
  };

  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">
                  List of Questions and Answers
                </div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn btn-primary d-inline-block"
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    {/* <div className="card-head">
                                            
                                            <div className="tools">
                                               
                                            </div>
                                        </div> */}
                    <div className="card-body ">
                      <div className="table-responsive">
                        <table className="table table-striped custom-table table-hover">
                          <thead>
                            <tr>
                              <th>Question ID</th>
                              <th>Intents</th>
                              <th>Answer 1</th>
                              <th>Answer 2</th>
                              <th>Emotion</th>
                              <th>Type</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Record > 10
                              ? paginatedPosts &&
                                paginatedPosts.length > 0 &&
                                paginatedPosts.map((item) => (
                                  // IntentList && IntentList.length > 0 && IntentList.map(item => (
                                  <tr>
                                    <td>
                                      <span>{item.id}</span>
                                    </td>
                                    <td>
                                      <span>{item.intents}</span>
                                    </td>
                                    <td className="text-left">
                                      {item.responce1}
                                    </td>
                                    <td className="text-left">
                                      {item.responce2}
                                    </td>
                                    <td className="text-left">
                                      {item.emotion == "Neural"
                                        ? "Neutral"
                                        : item.emotion}
                                    </td>
                                    <td className="text-left">
                                      {item.emoType}
                                    </td>
                                    <td className="action-cell">
                                      <Link
                                        to="/UpdateIntents"
                                        onClick={() =>
                                          EditIntents(
                                            item.id,
                                            item.intents,
                                            item.responce1,
                                            item.responce2,
                                            "Intentback"
                                          )
                                        }
                                        className="btn btn-primary btn-xs py-2"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </Link>

                                      <button
                                        className="btn btn-danger btn-xs py-2"
                                        onClick={() => deleteIntent(item.id)}
                                      >
                                        <i className="fa fa-trash-o "></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              : IntentList2 &&
                                IntentList2.length > 0 &&
                                IntentList2.map((item) => (
                                  <tr>
                                    <td>
                                      <span>{item.id}</span>
                                    </td>
                                    <td>
                                      <span>{item.intents}</span>
                                    </td>
                                    <td className="text-left">
                                      {item.responce1}
                                    </td>
                                    <td className="text-left">
                                      {item.responce2}
                                    </td>
                                    <td className="text-left">
                                      {item.emotion == "Neural"
                                        ? "Neutral"
                                        : item.emotion}
                                    </td>

                                    <td className="text-left">
                                      {item.emo_Type}
                                    </td>
                                    <td className="action-cell">
                                      <Link
                                        to="/UpdateIntents"
                                        onClick={() =>
                                          EditIntents(
                                            item.id,
                                            item.intents,
                                            item.responce1,
                                            item.responce2,
                                            "Intentback"
                                          )
                                        }
                                        className="btn btn-primary btn-xs py-2"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </Link>

                                      <button
                                        className="btn btn-danger btn-xs py-2"
                                        onClick={() => deleteIntent(item.id)}
                                      >
                                        <i className="fa fa-trash-o "></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                          </tbody>
                        </table>
                      </div>
                      {Record > 10 ? (
                        <ReactPaginate
                          previousLabel={"Prev"}
                          nextLabel={"Next"}
                          breakLabel={"..."}
                          pageCount={pageCount}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={3}
                          onPageChange={handlePageClick}
                          containerClassName={
                            "pagination justify-content-center"
                          }
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          activeClassName={"active"}
                          previousClassName={"page-item"}
                          nextClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextLinkClassName={"page-link"}
                        />
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default IntentList;
